import { Html } from '@mv/ui-kit/primitives';

export function CtaTileIllustration({ uri }: { uri: string }) {
	return <Html.Image alt="" className="size-12" resizeMode="contain" source={{ uri }} />;
}
